/**
 * Card names (CR 132): a card is identified by its full name; different subtitles are different names
 * (CR 132.4) and translations share one (CR 132.3). Copy limits and ban lists compare names, so they
 * are normalised the way Runebound does (`@rifted/core` `normaliseCardName`): variant parentheticals
 * dropped, "Name - Title" read as "Name, Title", accents, case and punctuation folded.
 */

const VARIANT_PARENTHETICAL =
  /\s*\((alternate art|alt art|showcase|signature|signed|overnumbered|promo|foil|[^)]*promo[^)]*)\)\s*/gi;

/** Catalogue variant rows that are not separate cards (research 03 §1.5): `(Metal)`, `(Starter)`, … */
export const VARIANT_SUFFIX = /\s*\((Metal|Starter|Launch Exclusive|GG EZ|Ultimate)\)\s*$/;

/** Token rows named after their art number and back (`Recruit (271) // Buff`). */
export const TOKEN_ROW_SUFFIX = /\s*(?:\(\d+\)\s*)?\/\/\s*Buff\s*$/;

/** Strips variant parentheticals and normalises "Name - Title" to "Name, Title". */
export function displayCardName(raw: string): string {
  return raw
    .replace(VARIANT_PARENTHETICAL, ' ')
    .trim()
    .replace(/\s+-\s+/g, ', ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Folds diacritics and case. */
export function foldText(text: string): string {
  return text.normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

/** `"Draven - Vanquisher (Promo)"` → `"draven vanquisher"`: the key copy limits and bans compare. */
export function normaliseCardName(name: string): string {
  return foldText(displayCardName(name))
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

/** The rules name of a catalogue row: variant and token-art suffixes removed (`Ahri, Alluring`). */
export function rulesName(name: string): string {
  return name.replace(VARIANT_SUFFIX, '').replace(TOKEN_ROW_SUFFIX, '').trim();
}
